import React, { useContext, useState } from 'react'
import './index.scss'
import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import { USER_VERIFICATION_STATUSES } from '@Const/user-statuses'
import ModalPortal from '@Components/Popups/ModalPortal'
import Popup from '@Components/Popups/Popup'
import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'

interface ButtonRegistrationRightsHolderProps {
    mainColor: boolean
}

const ButtonRegistrationRightsHolder = (props: ButtonRegistrationRightsHolderProps) => {
    const { userStore } = useContext(StoresContext)

    const [notVerifiedPopupIsOpen, setNotVerifiedPopupIsOpen] = useState(false)

    return (
        <>
            {userStore.userInfo && userStore.userInfo.verificationStatus === USER_VERIFICATION_STATUSES.VERIFIED ? (
                <Button
                    mainColor={props.mainColor}
                    type="primary"
                    icon={ICONS.add}
                    typeLink
                    linkTo={Navigation.registrationRightsholder.form()}
                >
                    Create a Member
                </Button>
            ) : (
                <Button
                    mainColor={props.mainColor}
                    type="primary"
                    icon={ICONS.add}
                    onClick={() => setNotVerifiedPopupIsOpen(true)}
                >
                    Create a Member
                </Button>
            )}
            <ModalPortal isOpen={notVerifiedPopupIsOpen} onClose={() => setNotVerifiedPopupIsOpen(false)}>
                <Popup onClose={() => setNotVerifiedPopupIsOpen(false)}>
                    <div className="not-verified-popup-content">
                        <h4>You must be verified before you can register a Member</h4>

                        <p>
                            Please fill out all User Information in your Profile and click the &quot;Get Verified&quot;
                            link. Need help? <a href={Navigation.contactUs.root()}>Contact Support</a>.
                        </p>

                        <div className="buttons-block">
                            <Button mainColor type="secondary" onClick={() => setNotVerifiedPopupIsOpen(false)}>
                                Cancel
                            </Button>
                            <Button mainColor type="primary" typeLink linkTo={Navigation.profile.user()}>
                                Get Verified
                            </Button>
                        </div>
                    </div>
                </Popup>
            </ModalPortal>
        </>
    )
}

export default ButtonRegistrationRightsHolder
